import React from "react";
import Form from "./common/form";
import { resetPassword, confirmResetPassword } from "aws-amplify/auth";

class ResetPassword extends Form {
  state = {
    data: {
      code: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    codeSent: false,
    confirmed: false,
    isConfirming: false,
    isSendingCode: false,
    errors: {},
  };

  validateEmailForm = () => {
    const { email } = this.state.data;
    return email.length > 0 && email.includes("@") && email.includes(".");
  };

  validateResetForm = () => {
    const { code, password, confirmPassword } = this.state.data;
    return (
      code.length > 0 && password.length > 0 && password === confirmPassword
    );
  };

  validateCompleteSignUpFormLength = () => {
    const { password } = this.state.data;
    return password.length > 7;
  };

  validateCompleteSignUpFormMatch = () => {
    const { password, confirmPassword } = this.state.data;
    return confirmPassword.length > 7 && password === confirmPassword;
  };

  validateCompleteSignUpFormNumber = () => {
    const { password } = this.state.data;
    return /\d/.test(password);
  };

  validateCompleteSignUpFormSpecialChar = () => {
    const { password } = this.state.data;
    return /[$&+,:;=?@#|'<>.^*()%!_-]/.test(password);
  };

  validateCompleteSignUpFormUpper = () => {
    const { password } = this.state.data;
    return /[A-Z]/.test(password);
  };

  validateCompleteSignUpFormLower = () => {
    const { password } = this.state.data;
    return /[a-z]/.test(password);
  };

  handleSendCodeClick = async (event) => {
    event.preventDefault();

    this.setState({ isSendingCode: true });

    try {
      await resetPassword({ username: this.state.data.email });
      this.setState({ codeSent: true });
    } catch (error) {
      this.onError(error);
      this.setState({ isSendingCode: true });
      alert(error.message);
    }
  };

  handleConfirmClick = async (event) => {
    event.preventDefault();
    const { email, code, password } = this.state.data;

    this.setState({ IsConfirming: true });

    try {
      await confirmResetPassword({
        username: email,
        confirmationCode: code,
        newPassword: password,
      });
      this.setState({ Confirmed: true });
      window.location = "/";
    } catch (error) {
      this.onError(error);
      this.setState({ IsConfirming: true });
    }
  };

  renderRequestCodeForm = () => {
    return (
      <div className="mx-auto mt-3 card" style={{ width: "auto" }}>
        <form onSubmit={this.handleSendCodeClick}>
          <div className="m-3">
            <h1>Reset Password</h1>
            <h6>Enter your email to get a verification code</h6>
            {this.renderInput(
              "email",
              "Email:",
              undefined,
              undefined,
              undefined,
              undefined,
              undefined,
              "black"
            )}
            <button
              style={{ width: "100%" }}
              type={"submit"}
              className={
                this.validateEmailForm()
                  ? "btn btn-primary mt-3"
                  : "btn btn-secondary mt-3"
              }
              disabled={!this.validateEmailForm()}
            >
              Send Code
            </button>
          </div>
        </form>
      </div>
    );
  };

  renderConfirmationForm = () => {
    return (
      <div className="mx-auto mt-3 card" style={{ width: "auto" }}>
        <form onSubmit={this.handleConfirmClick} className="m-3">
          <h1>Reset Password</h1>
          {this.renderInput(
            "code",
            "Confirmation Code:",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            "black"
          )}
          <h6>Please check your email for the code.</h6>
          <div className="dropdown-divider"></div>
          {this.renderInput(
            "password",
            "Password",
            "password",
            undefined,
            undefined,
            undefined,
            undefined,
            "black"
          )}
          {this.renderInput(
            "confirmPassword",
            "Confirm Password",
            "password",
            undefined,
            undefined,
            undefined,
            undefined,
            "black"
          )}
          <button
            style={{ width: "100%" }}
            type={"submit"}
            className={
              this.validateCompleteSignUpFormLength() &&
              this.validateCompleteSignUpFormNumber() &&
              this.validateCompleteSignUpFormSpecialChar() &&
              this.validateCompleteSignUpFormUpper() &&
              this.validateCompleteSignUpFormLower() &&
              this.validateCompleteSignUpFormMatch()
                ? "btn btn-primary mt-3"
                : "btn btn-secondary mt-3"
            }
            disabled={
              this.validateCompleteSignUpFormLength() &&
              this.validateCompleteSignUpFormNumber() &&
              this.validateCompleteSignUpFormSpecialChar() &&
              this.validateCompleteSignUpFormUpper() &&
              this.validateCompleteSignUpFormLower() &&
              this.validateCompleteSignUpFormMatch()
                ? false
                : true
            }
          >
            Go to Login Page
          </button>
          <div className="text-start">
            <h4 style={{ marginTop: "10px" }}>Password Requirements:</h4>
            <div>
              <span
                className={
                  this.validateCompleteSignUpFormLength()
                    ? "dot-success"
                    : "dot-required"
                }
              ></span>{" "}
              Requires at least a length of 8 characters
            </div>
            <div>
              <span
                className={
                  this.validateCompleteSignUpFormNumber()
                    ? "dot-success"
                    : "dot-required"
                }
              ></span>{" "}
              Requires at least a number
            </div>
            <div>
              <span
                className={
                  this.validateCompleteSignUpFormLower()
                    ? "dot-success"
                    : "dot-required"
                }
              ></span>{" "}
              Requires at least a lower case character
            </div>
            <div>
              <span
                className={
                  this.validateCompleteSignUpFormUpper()
                    ? "dot-success"
                    : "dot-required"
                }
              ></span>{" "}
              Requires at least an UPPER case character
            </div>
            <div>
              <span
                className={
                  this.validateCompleteSignUpFormSpecialChar()
                    ? "dot-success"
                    : "dot-required"
                }
              ></span>{" "}
              Requires at least a special character
            </div>
            <div>
              <span
                className={
                  this.validateCompleteSignUpFormMatch()
                    ? "dot-success"
                    : "dot-required"
                }
              ></span>{" "}
              Passwords match
            </div>
          </div>
        </form>
      </div>
    );
  };

  onError = (error) => {
    let errorInfo = {};
    let message = error.toString();

    // Auth errors
    if (!(error instanceof Error) && error.message) {
      errorInfo = error;
      message = error.message;
      error = new Error(message);
      // API errors
    } else if (error.config && error.config.url) {
      errorInfo.url = error.config.url;
    }

    alert(message);
  };

  render() {
    return (
      <React.Fragment>
        <div>
          <div className="row g-3">
            <div className="col-lg-5 mx-auto">
              {!this.state.codeSent
                ? this.renderRequestCodeForm()
                : !this.state.confirmed
                ? this.renderConfirmationForm()
                : this.renderSuccessMessage()}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ResetPassword;
